"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGiftLink = exports.getSendAsPersonIsLoading = exports.getSendAsPerson = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var getSendAsPersonState = function getSendAsPersonState(state) {
  return state.modules.giftingOnTheFly.campaign.sendAsPerson;
};

var getSendAsPerson = (0, _ramda.pipe)(getSendAsPersonState, function (state) {
  return state.sendAsPerson;
});
exports.getSendAsPerson = getSendAsPerson;
var getSendAsPersonIsLoading = (0, _ramda.pipe)(getSendAsPersonState, function (state) {
  return state.status === _utils.StateStatus.Pending;
});
exports.getSendAsPersonIsLoading = getSendAsPersonIsLoading;
var getGiftLink = (0, _ramda.pipe)(getSendAsPerson, function (sendAs) {
  return sendAs === null || sendAs === void 0 ? void 0 : sendAs.giftLink;
});
exports.getGiftLink = getGiftLink;